import { render, staticRenderFns } from "./DetailsSofort.vue?vue&type=template&id=61fea729&scoped=true"
import script from "./DetailsSofort.vue?vue&type=script&lang=ts"
export * from "./DetailsSofort.vue?vue&type=script&lang=ts"
import style0 from "./DetailsSofort.vue?vue&type=style&index=0&id=61fea729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fea729",
  null
  
)

export default component.exports